import { LogoMark } from "./Logo";
import { IMAGES } from "../data/content";

// Card/hero visual for a case study: photo + logo when approved imagery exists,
// otherwise a clean branded panel with the brand name (no unapproved brand assets).
export const CaseVisual = ({ c, className = "aspect-[16/10]" }) =>
    c.image ? (
        <div className={`relative rounded-lg overflow-hidden bg-navy-900 ${className}`}>
            <img src={IMAGES[c.image]} alt={c.alt} loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-navy-950/55 via-navy-950/20 to-navy-950/10" aria-hidden="true" />
            <div className="absolute inset-0 flex items-center justify-center p-6">
                <div className="bg-white rounded-xl shadow-[0_12px_40px_rgba(7,14,26,0.35)] px-7 py-5 w-[70%] max-w-[280px] flex items-center justify-center">
                    <img src={c.logo} alt={`${c.client} logo`} className="w-full h-auto max-h-16 object-contain" />
                </div>
            </div>
        </div>
    ) : (
        <div className={`relative rounded-lg overflow-hidden bg-navy-900 border border-white/10 flex flex-col items-center justify-center text-center px-6 ${className}`}>
            <div className="absolute -right-16 -top-16 w-56 h-56 rounded-full bg-gold-500/10 blur-2xl" aria-hidden="true" />
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-gold-400">{c.meta?.[0]?.value}</p>
            <p className="mt-3 font-serif font-semibold text-3xl sm:text-4xl text-white">{c.client}</p>
            <span className="mt-4 h-px w-16 bg-gold-500/60" aria-hidden="true" />
            <div className="mt-4 flex items-center gap-2 text-slate-400">
                <LogoMark size={18} />
                <span className="font-mono text-[10px] tracking-[0.25em] uppercase">New Zealand</span>
            </div>
        </div>
    );
